import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface UnassignConfirmDialogProps {
    open: boolean;
    chipLabel: string | null;
    chipExternalCode?: string | null;
    onConfirm: () => void;
    onCancel: () => void;
    isLoading?: boolean;
}

// דיאלוג אישור לפני ניתוק שיוך כרטיס ממשתמש.
export function UnassignConfirmDialog({open, chipLabel, chipExternalCode, onConfirm, onCancel, isLoading}: UnassignConfirmDialogProps) {
    return (
        <AlertDialog open={open} onOpenChange={(value) => { if (!value) onCancel(); }}>
            <AlertDialogContent dir="rtl">
                <AlertDialogHeader className="text-right sm:text-right">
                    <AlertDialogTitle>ניתוק שיוך כרטיס</AlertDialogTitle>
                    <AlertDialogDescription className="text-base">
                        האם לנתק את השיוך של כרטיס עם קוד פנימי <strong>{chipLabel || ''}</strong>
                        {chipExternalCode ? <> וקוד חיצוני <strong>{chipExternalCode}</strong></> : ''} מהמשתמש? פעולה זו ניתנת לביטול על ידי שיוך מחדש.
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter className="sm:justify-start sm:flex-row-reverse">
                    <AlertDialogCancel disabled={isLoading}>ביטול</AlertDialogCancel>
                    <AlertDialogAction onClick={onConfirm} disabled={isLoading}>
                        {isLoading ? "מנתק..." : "כן, נתק שיוך"}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
